(() => {

    angular.module('services')
        .factory('Interpolation', () => ({
            setLocale: () => { },

            interpolate: (string, interpolateParams) => {

                if (!angular.isObject(interpolateParams)) {

                    return string;

                }
                string = string.split(' ');
                string = _.map(string, (word) => {

                    const startIdx = word.indexOf('__');
                    const endIdx = word.lastIndexOf('__');
                    let solved = '';
                    if (startIdx >= 0 && endIdx >= 0 && startIdx !== endIdx) {

                        solved = interpolateParams[word.slice(startIdx + 2, endIdx)];
                        if (!angular.isUndefined(solved)) {

                            word = word.slice(0, startIdx) + solved + word.slice(endIdx + 2);

                        }
                        return word;

                    }
                    return word;

                });
                return string.join(' ');

            },
        }));

})();



// WEBPACK FOOTER //
// ./scripts/common/services/translation/Interpolation.js